// Versão do app - gerado automaticamente
export const APP_VERSION = '5.34'
export const BUILD_DATE = '09/05/2026, 04:44'
